import { render, staticRenderFns } from "./SelectFavourites.vue?vue&type=template&id=8d93e2ec&scoped=true"
import script from "./SelectFavourites.vue?vue&type=script&lang=js"
export * from "./SelectFavourites.vue?vue&type=script&lang=js"
import style0 from "./SelectFavourites.vue?vue&type=style&index=0&id=8d93e2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d93e2ec",
  null
  
)

export default component.exports